import React from "react";
import { Link } from "react-router-dom";
import { BsDot, BsFillShareFill } from "react-icons/bs";
import { MdPhonelink } from "react-icons/md";
import { FaHeadset, FaUserCog } from "react-icons/fa";
import Info from "../../atoms/Info/Info";
import companyimage from "../../../images/bg/5.jpg";
import "./About.css";
import Team from "../../atoms/Team/Team";
import Footer from "../../molecules/Footer/Footer";
import Foot from "../../molecules/Foot/Foot";

const About = () => {
  const decor = {
    textDecoration: "none",
  };

  return (
    <div>
      <div className="listing-container">
        <div className="listing-heading">
          <div className="inner">
            <h4>About Us</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut nec
              tincidunt arcu, sit amet fermentum sem.
            </p>
          </div>
        </div>
        <div className="trry">
          {" "}
          <div className="wrap-mini">
            <div className="list-starter">
              <div className="home-list">
                <div className="dot">
                  <Link style={decor} to="/">
                    <li className="home">Home</li>
                  </Link>{" "}
                  <BsDot className="dotted-icon" />
                </div>
                <div className="dot">
                  <Link style={decor} to="/about">
                    <li className="home">About</li>
                  </Link>{" "}
                  <BsDot className="dotted-icon" />
                </div>
              </div>
              <div className="share">
                <BsFillShareFill className="share-icon" />
                <p className="share-text">Share</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="about-container">
        <div className="about-wrapper">
          <div className="about-grid-wrapper">
            <div className="about-flex">
              <div className="about-first">
                <FaHeadset />
              </div>
              <div className="about-second">
                <div className="about-third">
                  <h4>24 Hours Support</h4>
                  <h2>01</h2>
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Maecenas in pulvinar neque. Nulla finibus lobortis pulvinar.
                </p>
              </div>
            </div>
            <div className="about-flex">
              <div className="about-first">
                <FaUserCog />
              </div>
              <div className="about-second">
                <div className="about-third">
                  <h4>24 Hours Support</h4>
                  <h2>01</h2>
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Maecenas in pulvinar neque. Nulla finibus lobortis pulvinar.
                </p>
              </div>
            </div>
            <div className="about-flex">
              <div className="about-first">
                <MdPhonelink />
              </div>
              <div className="about-second">
                <div className="about-third">
                  <h4>24 Hours Support</h4>
                  <h2>01</h2>
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Maecenas in pulvinar neque. Nulla finibus lobortis pulvinar.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="company-story-wrapper">
        <div className="company-story">
          <div className="company-story-left">
            <h2>Our Company Story</h2>
            <h4>Check video presentation to find out more about us .</h4>
            <p>
              Ut euismod ultricies sollicitudin. Curabitur sed dapibus nulla.
              Nulla eget iaculis lectus. Mauris ac maximus neque. Nam in mauris
              quis libero sodales eleifend. Morbi varius, nulla sit amet rutrum
              elementum, est elit finibus tellus, ut tristique elit risus at
              metus.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
              in pulvinar neque. Nulla finibus lobortis pulvinar. Donec a
              consectetur nulla. Nulla posuere sapien vitae lectus suscipit, et
              pulvinar nisi tincidunt. Aliquam erat volutpat. Curabitur
              convallis fringilla diam sed aliquam. Sed tempor iaculis massa
              faucibus feugiat. In fermentum facilisis massa, a consequat purus
              viverra.
            </p>
          </div>
          <div>
            <img className="company-img" src={companyimage} alt="company-img" />
          </div>
        </div>
      </div>
      <Info />
      <div className="team-wrapper">
        <div className="sec-three-header">
          <h4>THE CREW</h4>
          <h3>Our Awesome team</h3>
        </div>
        <div className="about-wrapper">
          <Team />
        </div>
      </div>
      <div className="section-footer">
        <div className="inner-footer">
          <Footer />
        </div>
      </div>
      <div className="mini-footer">
        <div className="mini-footerr">
          <Foot />
        </div>
      </div>
    </div>
  );
};

export default About;
